import { useMutation, useQueryClient } from '@tanstack/react-query'
import { postData } from '../utils'
import { reloadActiveRelations, reloadBatches, reloadSchool } from '../utils/loadStorage'
import { TankValuesArrayType } from '../types/apiResponse/tankTypes'

const stockAPI = async (tankInfo: TankValuesArrayType) => {
  const response = await postData<string[]>('/stock', tankInfo)

  reloadSchool(response)
  reloadBatches()
  reloadActiveRelations()

  return response
}

export const useStock = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (tankInfo: TankValuesArrayType) => stockAPI(tankInfo),

    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['tankInfo'] })
      queryClient.invalidateQueries({ queryKey: ['undoable'] })
    },

    onError: (error) => {
      console.log('Stock API Error:', error)
    },
  })
}
